// Dados de exemplo no formato de GET /rpg/jogadores e GET /rpg/jogador/:slug (docs/api-publica-rpg.md da API).
// O Provider usa estes dados quando a API nao responde.
// detalhesJogadores guarda, por slug, so o que o perfil acrescenta ao resumo da lista.
module.exports = {
  jogadoresList: [
    {
      posicao: 1,
      discordId: "300000000000000002",
      slug: "luffy_mugen",
      nome: "luffy_mugen",
      avatar: "https://cdn.discordapp.com/embed/avatars/2.png",
      roblox: { username: "luffy_mugen", perfil: "https://www.roblox.com/users/2210457763/profile" },
      crew: { nome: "Void Alpha", slug: "void-alpha" },
      nivel: 29,
      xp: 57950,
      progresso: { nivel: 29, xpTotal: 57950, xpNoNivel: 2750, xpDoNivel: 5216, falta: 2466, percentual: 52 },
      patente: { key: "YONKOU", nome: "Yonkou", cor: "#facc15", icone: "👑", imagem: "" },
      reis: [{ chave: "imperador-dos-mares", nome: "Imperador dos Mares", cor: "#3b82f6" }],
      categorias: {
        "rei-das-raids": { valor: 20, posicao: 2 },
        "rei-do-pvp": { valor: 12, posicao: 2 },
        "imperador-dos-mares": { valor: 47, posicao: 1 },
        "magnata-dos-mares": { valor: 480000, posicao: 2 },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 122, posicao: 4 },
      },
    },
    {
      posicao: 2,
      discordId: "300000000000000001",
      slug: "zoro_void",
      nome: "zoro_void",
      avatar: "https://cdn.discordapp.com/embed/avatars/1.png",
      roblox: { username: "zoro_void", perfil: "https://www.roblox.com/users/1843220011/profile" },
      crew: { nome: "Void Alpha", slug: "void-alpha" },
      nivel: 26,
      xp: 41330,
      progresso: { nivel: 26, xpTotal: 41330, xpNoNivel: 58, xpDoNivel: 4363, falta: 4305, percentual: 1 },
      patente: { key: "SUPERNOVA", nome: "Supernova", cor: "#f97316", icone: "⭐", imagem: "" },
      reis: [{ chave: "rei-do-pvp", nome: "Rei do PvP", cor: "#9b4dff" }],
      categorias: {
        "rei-das-raids": { valor: 14, posicao: 4 },
        "rei-do-pvp": { valor: 28, posicao: 1 },
        "imperador-dos-mares": { valor: 7, posicao: 3 },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 90, posicao: 6 },
      },
    },
    {
      posicao: 3,
      discordId: "300000000000000004",
      slug: "sanji_blackleg",
      nome: "sanji_blackleg",
      avatar: "https://cdn.discordapp.com/embed/avatars/4.png",
      roblox: { username: "sanji_blackleg", perfil: "https://www.roblox.com/users/1502998410/profile" },
      crew: { nome: "Void Beta", slug: "void-beta" },
      nivel: 23,
      xp: 32090,
      progresso: { nivel: 23, xpTotal: 32090, xpNoNivel: 2309, xpDoNivel: 3571, falta: 1262, percentual: 64 },
      patente: { key: "ROOKIE", nome: "Rookie", cor: "#7f00ff", icone: "🔰", imagem: "" },
      reis: [{ chave: "rei-das-raids", nome: "Rei das Raids", cor: "#ff4d4d" }],
      categorias: {
        "rei-das-raids": { valor: 42, posicao: 1 },
        "rei-do-pvp": { valor: 5, posicao: 5 },
        "imperador-dos-mares": { valor: 0, posicao: null },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 52, posicao: 8 },
      },
    },
    {
      posicao: 4,
      discordId: "300000000000000012",
      slug: "yamato_oni",
      nome: "yamato_oni",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      roblox: { username: "yamato_oni", perfil: "https://www.roblox.com/users/3902117736/profile" },
      crew: { nome: "Void Beta", slug: "void-beta" },
      nivel: 23,
      xp: 30650,
      progresso: { nivel: 23, xpTotal: 30650, xpNoNivel: 869, xpDoNivel: 3571, falta: 2702, percentual: 24 },
      patente: { key: "SUPERNOVA", nome: "Supernova", cor: "#f97316", icone: "⭐", imagem: "" },
      reis: [],
      categorias: {
        "rei-das-raids": { valor: 12, posicao: 5 },
        "rei-do-pvp": { valor: 10, posicao: 3 },
        "imperador-dos-mares": { valor: 1, posicao: 7 },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 268, posicao: 1 },
      },
    },
    {
      posicao: 5,
      discordId: "300000000000000005",
      slug: "robin_ohara",
      nome: "robin_ohara",
      avatar: "https://cdn.discordapp.com/embed/avatars/5.png",
      roblox: { username: "robin_ohara", perfil: "https://www.roblox.com/users/3377120954/profile" },
      crew: { nome: "Void Beta", slug: "void-beta" },
      nivel: 22,
      xp: 27350,
      progresso: { nivel: 22, xpTotal: 27350, xpNoNivel: 890, xpDoNivel: 3321, falta: 2431, percentual: 26 },
      patente: { key: "SUPERNOVA", nome: "Supernova", cor: "#f97316", icone: "⭐", imagem: "" },
      reis: [{ chave: "lorde-dos-fragmentos", nome: "Lorde dos Fragmentos", cor: "#22d3ee" }],
      categorias: {
        "rei-das-raids": { valor: 18, posicao: 3 },
        "rei-do-pvp": { valor: 0, posicao: null },
        "imperador-dos-mares": { valor: 5, posicao: 4 },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 96000, posicao: 1 },
        "lenda-viva": { valor: 211, posicao: 2 },
      },
    },
    {
      posicao: 6,
      discordId: "300000000000000009",
      slug: "brook_soul",
      nome: "brook_soul",
      avatar: "https://cdn.discordapp.com/embed/avatars/3.png",
      roblox: { username: "brook_soul", perfil: "https://www.roblox.com/users/1964408822/profile" },
      crew: { nome: "Void Gamma", slug: "void-gamma" },
      nivel: 18,
      xp: 15800,
      progresso: { nivel: 18, xpTotal: 15800, xpNoNivel: 275, xpDoNivel: 2396, falta: 2121, percentual: 11 },
      patente: { key: "ROOKIE", nome: "Rookie", cor: "#7f00ff", icone: "🔰", imagem: "" },
      reis: [],
      categorias: {
        "rei-das-raids": { valor: 6, posicao: 7 },
        "rei-do-pvp": { valor: 3, posicao: 6 },
        "imperador-dos-mares": { valor: 0, posicao: null },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 0, posicao: null },
      },
    },
    {
      posicao: 7,
      discordId: "300000000000000007",
      slug: "chopper_doc",
      nome: "chopper_doc",
      avatar: "https://cdn.discordapp.com/embed/avatars/1.png",
      roblox: { username: "chopper_doc", perfil: "https://www.roblox.com/users/2893310045/profile" },
      crew: { nome: "Void Gamma", slug: "void-gamma" },
      nivel: 17,
      xp: 15060,
      progresso: { nivel: 17, xpTotal: 15060, xpNoNivel: 1719, xpDoNivel: 2184, falta: 465, percentual: 78 },
      patente: { key: "ROOKIE", nome: "Rookie", cor: "#7f00ff", icone: "🔰", imagem: "" },
      reis: [],
      categorias: {
        "rei-das-raids": { valor: 9, posicao: 6 },
        "rei-do-pvp": { valor: 0, posicao: null },
        "imperador-dos-mares": { valor: 4, posicao: 5 },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 100, posicao: 5 },
      },
    },
    {
      posicao: 8,
      discordId: "300000000000000003",
      slug: "300000000000000003",
      nome: "Nami ✦",
      avatar: "https://cdn.discordapp.com/embed/avatars/3.png",
      roblox: null,
      crew: null,
      nivel: 17,
      xp: 14750,
      progresso: { nivel: 17, xpTotal: 14750, xpNoNivel: 1409, xpDoNivel: 2184, falta: 775, percentual: 64 },
      patente: null,
      reis: [{ chave: "magnata-dos-mares", nome: "Magnata dos Mares", cor: "#facc15" }],
      categorias: {
        "rei-das-raids": { valor: 3, posicao: 9 },
        "rei-do-pvp": { valor: 0, posicao: null },
        "imperador-dos-mares": { valor: 0, posicao: null },
        "magnata-dos-mares": { valor: 1850000, posicao: 1 },
        "lorde-dos-fragmentos": { valor: 32000, posicao: 2 },
        "lenda-viva": { valor: 150, posicao: 3 },
      },
    },
    {
      posicao: 9,
      discordId: "300000000000000010",
      slug: "jinbe_mar",
      nome: "jinbe_mar",
      avatar: "https://cdn.discordapp.com/embed/avatars/4.png",
      roblox: { username: "jinbe_mar", perfil: "https://www.roblox.com/users/2755019363/profile" },
      crew: { nome: "Void Alpha", slug: "void-alpha" },
      nivel: 15,
      xp: 11350,
      progresso: { nivel: 15, xpTotal: 11350, xpNoNivel: 1773, xpDoNivel: 1784, falta: 11, percentual: 99 },
      patente: null,
      reis: [],
      categorias: {
        "rei-das-raids": { valor: 4, posicao: 8 },
        "rei-do-pvp": { valor: 0, posicao: null },
        "imperador-dos-mares": { valor: 17, posicao: 2 },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 0, posicao: null },
      },
    },
    {
      posicao: 10,
      discordId: "300000000000000006",
      slug: "usopp_sniper",
      nome: "usopp_sniper",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      roblox: { username: "usopp_sniper", perfil: "https://www.roblox.com/users/4120037781/profile" },
      crew: null,
      nivel: 15,
      xp: 10700,
      progresso: { nivel: 15, xpTotal: 10700, xpNoNivel: 1123, xpDoNivel: 1784, falta: 661, percentual: 62 },
      patente: null,
      reis: [],
      categorias: {
        "rei-das-raids": { valor: 0, posicao: null },
        "rei-do-pvp": { valor: 7, posicao: 4 },
        "imperador-dos-mares": { valor: 2, posicao: 6 },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 60, posicao: 7 },
      },
    },
    {
      posicao: 11,
      discordId: "300000000000000008",
      slug: "300000000000000008",
      nome: "Franky SUPER",
      avatar: "https://cdn.discordapp.com/embed/avatars/1.png",
      roblox: null,
      crew: null,
      nivel: 12,
      xp: 6000,
      progresso: { nivel: 12, xpTotal: 6000, xpNoNivel: 683, xpDoNivel: 1247, falta: 564, percentual: 54 },
      patente: { key: "ROOKIE", nome: "Rookie", cor: "#7f00ff", icone: "🔰", imagem: "" },
      reis: [],
      categorias: {
        "rei-das-raids": { valor: 0, posicao: null },
        "rei-do-pvp": { valor: 0, posicao: null },
        "imperador-dos-mares": { valor: 1, posicao: 8 },
        "magnata-dos-mares": { valor: 360000, posicao: 3 },
        "lorde-dos-fragmentos": { valor: 12500, posicao: 3 },
        "lenda-viva": { valor: 0, posicao: null },
      },
    },
    {
      posicao: 12,
      discordId: "300000000000000011",
      slug: "300000000000000011",
      nome: "Law 🩺",
      avatar: "https://cdn.discordapp.com/embed/avatars/5.png",
      roblox: null,
      crew: null,
      nivel: 7,
      xp: 1320,
      progresso: { nivel: 7, xpTotal: 1320, xpNoNivel: 7, xpDoNivel: 536, falta: 529, percentual: 1 },
      patente: null,
      reis: [],
      categorias: {
        "rei-das-raids": { valor: 0, posicao: null },
        "rei-do-pvp": { valor: 0, posicao: null },
        "imperador-dos-mares": { valor: 0, posicao: null },
        "magnata-dos-mares": { valor: 0, posicao: null },
        "lorde-dos-fragmentos": { valor: 0, posicao: null },
        "lenda-viva": { valor: 26, posicao: 9 },
      },
    },
  ],
  detalhesJogadores: {
    luffy_mugen: {
      membroDesde: "2025-06-18T15:02:00.000Z",
      atividades: [
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 20, total: 20 },
        { key: "sea_beast", nome: "Sea Beast", emoji: "🌊", vezes: 14, total: 14 },
        { key: "pvp_win", nome: "PvP vitória", emoji: "🥇", vezes: 12, total: 12 },
        { key: "terroshark", nome: "Terroshark", emoji: "🦈", vezes: 11, total: 11 },
        { key: "leviathan", nome: "Leviathan", emoji: "🐲", vezes: 9, total: 9 },
        { key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 8, total: 110 },
        { key: "ghost_ship", nome: "Navio Fantasma", emoji: "👻", vezes: 7, total: 7 },
        { key: "volcano", nome: "Ilha do Vulcão", emoji: "🌋", vezes: 6, total: 6 },
        { key: "pvp_loss", nome: "PvP derrota", emoji: "🥈", vezes: 6, total: 6 },
        { key: "gold", nome: "Gold", emoji: "🪙", vezes: 5, total: 480000 },
        { key: "achievement", nome: "Conquista", emoji: "🏆", vezes: 4, total: 12 },
        { key: "dough_king", nome: "Dough King", emoji: "🍩", vezes: 2, total: 2 },
        { key: "tyrant_of_the_skies", nome: "Tyrant of the Skies", emoji: "🌩️", vezes: 1, total: 1 },
      ],
      insignias: [
        { key: "VETERANO_VOID", nome: "Veterano do Void", raridade: "RARE", icone: "🏴‍☠️", desde: "2025-12-18T12:00:00.000Z" },
        { key: "CACADOR_REIS_DO_MAR", nome: "Caçador de Reis do Mar", raridade: "LEGENDARY", icone: "🐲", desde: "2026-07-21T02:15:00.000Z" },
        { key: "CAPITAO", nome: "Capitão de Frota", raridade: "MYTHIC", icone: "🏴", desde: "2025-06-18T15:02:00.000Z" },
      ],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-26T02:13:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 29", emoji: "⬆️", xp: null, em: "2026-09-25T19:13:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Terroshark", emoji: "🦈", xp: 250, em: "2026-09-25T19:13:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Navio Fantasma", emoji: "👻", xp: 250, em: "2026-09-24T23:13:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Gold", emoji: "🪙", xp: 250, em: "2026-09-23T14:13:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Tyrant of the Skies", emoji: "🌩️", xp: 1250, em: "2026-09-22T21:13:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "PvP vitória", emoji: "🥇", xp: 400, em: "2026-09-21T15:13:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 280, em: "2026-09-21T01:13:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "PvP derrota", emoji: "🥈", xp: 100, em: "2026-09-19T22:13:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Dough King", emoji: "🍩", xp: 1250, em: "2026-09-19T11:13:00.000Z" },
      ],
    },
    zoro_void: {
      membroDesde: "2025-11-03T21:14:00.000Z",
      atividades: [
        { key: "pvp_win", nome: "PvP vitória", emoji: "🥇", vezes: 28, total: 28 },
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 14, total: 14 },
        { key: "pvp_loss", nome: "PvP derrota", emoji: "🥈", vezes: 9, total: 9 },
        { key: "dungeon", nome: "Dungeon", emoji: "🏰", vezes: 6, total: 6 },
        { key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 6, total: 84 },
        { key: "sea_beast", nome: "Sea Beast", emoji: "🌊", vezes: 5, total: 5 },
        { key: "soul_reaper", nome: "Soul Reaper", emoji: "☠️", vezes: 3, total: 3 },
        { key: "leviathan", nome: "Leviathan", emoji: "🐲", vezes: 2, total: 2 },
        { key: "achievement", nome: "Conquista", emoji: "🏆", vezes: 2, total: 6 },
      ],
      insignias: [
        { key: "PRIMEIRO_SANGUE", nome: "Primeiro Sangue", raridade: "UNCOMMON", icone: "🩸", desde: "2025-11-10T19:00:00.000Z" },
        { key: "DUELISTA", nome: "Duelista Implacável", raridade: "EPIC", icone: "⚔️", desde: "2026-08-02T23:40:00.000Z" },
      ],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-26T01:26:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 26", emoji: "⬆️", xp: null, em: "2026-09-25T13:26:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 280, em: "2026-09-25T13:26:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Leviathan", emoji: "🐲", xp: 750, em: "2026-09-24T12:26:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-24T03:26:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 280, em: "2026-09-23T05:26:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Leviathan", emoji: "🐲", xp: 750, em: "2026-09-21T18:26:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-20T23:26:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 280, em: "2026-09-19T15:26:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Leviathan", emoji: "🐲", xp: 750, em: "2026-09-18T23:26:00.000Z" },
      ],
    },
    sanji_blackleg: {
      membroDesde: "2025-09-27T22:45:00.000Z",
      atividades: [
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 42, total: 42 },
        { key: "dungeon", nome: "Dungeon", emoji: "🏰", vezes: 15, total: 15 },
        { key: "pvp_loss", nome: "PvP derrota", emoji: "🥈", vezes: 8, total: 8 },
        { key: "pvp_win", nome: "PvP vitória", emoji: "🥇", vezes: 5, total: 5 },
        { key: "cake_prince", nome: "Cake Prince", emoji: "👑", vezes: 4, total: 4 },
        { key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 4, total: 52 },
      ],
      insignias: [{ key: "MESTRE_DAS_RAIDS", nome: "Mestre das Raids", raridade: "EPIC", icone: "🧨", desde: "2026-06-30T01:10:00.000Z" }],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "PvP derrota", emoji: "🥈", xp: 100, em: "2026-09-26T00:39:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 23", emoji: "⬆️", xp: null, em: "2026-09-25T07:39:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 260, em: "2026-09-25T07:39:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "PvP derrota", emoji: "🥈", xp: 100, em: "2026-09-24T01:39:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 260, em: "2026-09-23T11:39:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "PvP derrota", emoji: "🥈", xp: 100, em: "2026-09-22T08:39:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 260, em: "2026-09-21T21:39:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "PvP derrota", emoji: "🥈", xp: 100, em: "2026-09-20T21:39:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 260, em: "2026-09-20T13:39:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "PvP derrota", emoji: "🥈", xp: 100, em: "2026-09-19T16:39:00.000Z" },
      ],
    },
    yamato_oni: {
      membroDesde: "2025-12-24T23:59:00.000Z",
      atividades: [
        { key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 15, total: 230 },
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 12, total: 12 },
        { key: "pvp_win", nome: "PvP vitória", emoji: "🥇", vezes: 10, total: 10 },
        { key: "achievement", nome: "Conquista", emoji: "🏆", vezes: 9, total: 38 },
        { key: "pvp_loss", nome: "PvP derrota", emoji: "🥈", vezes: 4, total: 4 },
        { key: "leviathan", nome: "Leviathan", emoji: "🐲", vezes: 1, total: 1 },
      ],
      insignias: [{ key: "MENTE_BRILHANTE", nome: "Mente Brilhante", raridade: "EPIC", icone: "🧠", desde: "2026-09-01T21:00:00.000Z" }],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "Conquista", emoji: "🏆", xp: 200, em: "2026-09-25T23:52:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 23", emoji: "⬆️", xp: null, em: "2026-09-25T01:52:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 300, em: "2026-09-25T01:52:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Conquista", emoji: "🏆", xp: 200, em: "2026-09-23T14:52:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 300, em: "2026-09-22T19:52:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Conquista", emoji: "🏆", xp: 200, em: "2026-09-21T11:52:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 300, em: "2026-09-20T19:52:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Conquista", emoji: "🏆", xp: 200, em: "2026-09-19T14:52:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 300, em: "2026-09-19T01:52:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Conquista", emoji: "🏆", xp: 200, em: "2026-09-17T23:52:00.000Z" },
      ],
    },
    robin_ohara: {
      membroDesde: "2025-10-12T13:20:00.000Z",
      atividades: [
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 18, total: 18 },
        { key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 12, total: 190 },
        { key: "fragments", nome: "Fragmentos", emoji: "💎", vezes: 11, total: 96000 },
        { key: "achievement", nome: "Conquista", emoji: "🏆", vezes: 6, total: 21 },
        { key: "sea_beast", nome: "Sea Beast", emoji: "🌊", vezes: 3, total: 3 },
        { key: "ghost_ship", nome: "Navio Fantasma", emoji: "👻", vezes: 2, total: 2 },
      ],
      insignias: [{ key: "LEITORA_PONEGLYPH", nome: "Leitora de Poneglyphs", raridade: "RARE", icone: "📜", desde: "2026-03-14T17:00:00.000Z" }],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "Sea Beast", emoji: "🌊", xp: 250, em: "2026-09-25T23:05:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 22", emoji: "⬆️", xp: null, em: "2026-09-24T20:05:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 320, em: "2026-09-24T20:05:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Sea Beast", emoji: "🌊", xp: 250, em: "2026-09-24T09:05:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 320, em: "2026-09-23T09:05:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Sea Beast", emoji: "🌊", xp: 250, em: "2026-09-23T01:05:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 320, em: "2026-09-22T04:05:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Sea Beast", emoji: "🌊", xp: 250, em: "2026-09-20T18:05:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 320, em: "2026-09-20T00:05:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Sea Beast", emoji: "🌊", xp: 250, em: "2026-09-18T17:05:00.000Z" },
      ],
    },
    brook_soul: {
      membroDesde: "2026-02-02T02:02:00.000Z",
      atividades: [
        { key: "soul_reaper", nome: "Soul Reaper", emoji: "☠️", vezes: 6, total: 6 },
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 6, total: 6 },
        { key: "pvp_win", nome: "PvP vitória", emoji: "🥇", vezes: 3, total: 3 },
        { key: "rip_indra_true_form", nome: "rip_indra True Form", emoji: "⚡", vezes: 2, total: 2 },
        { key: "pvp_loss", nome: "PvP derrota", emoji: "🥈", vezes: 2, total: 2 },
      ],
      insignias: [{ key: "ALMA_PENADA", nome: "Alma Penada", raridade: "UNCOMMON", icone: "💀", desde: "2026-05-05T03:30:00.000Z" }],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "Soul Reaper", emoji: "☠️", xp: 500, em: "2026-09-25T22:18:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 18", emoji: "⬆️", xp: null, em: "2026-09-24T14:18:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "rip_indra True Form", emoji: "⚡", xp: 750, em: "2026-09-24T14:18:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-23T22:18:00.000Z" },
      ],
    },
    chopper_doc: {
      membroDesde: "2026-01-15T11:40:00.000Z",
      atividades: [
        { key: "dungeon", nome: "Dungeon", emoji: "🏰", vezes: 11, total: 11 },
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 9, total: 9 },
        { key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 7, total: 98 },
        { key: "sea_beast", nome: "Sea Beast", emoji: "🌊", vezes: 4, total: 4 },
        { key: "achievement", nome: "Conquista", emoji: "🏆", vezes: 1, total: 2 },
      ],
      insignias: [{ key: "PRIMEIRO_PASSO", nome: "Primeiro Passo", raridade: "COMMON", icone: "👣", desde: "2026-01-16T14:00:00.000Z" }],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-25T21:31:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 17", emoji: "⬆️", xp: null, em: "2026-09-25T13:31:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Conquista", emoji: "🏆", xp: 100, em: "2026-09-25T13:31:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 280, em: "2026-09-24T16:31:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Dungeon", emoji: "🏰", xp: 250, em: "2026-09-23T06:31:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Sea Beast", emoji: "🌊", xp: 250, em: "2026-09-22T12:31:00.000Z" },
      ],
    },
    "300000000000000003": {
      membroDesde: "2026-04-09T18:30:00.000Z",
      atividades: [
        { key: "gold", nome: "Gold", emoji: "🪙", vezes: 14, total: 1850000 },
        { key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 10, total: 150 },
        { key: "fragments", nome: "Fragmentos", emoji: "💎", vezes: 6, total: 32000 },
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 3, total: 3 },
      ],
      insignias: [{ key: "PRIMEIRO_PASSO", nome: "Primeiro Passo", raridade: "COMMON", icone: "👣", desde: "2026-04-11T20:00:00.000Z" }],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-25T20:44:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 17", emoji: "⬆️", xp: null, em: "2026-09-25T07:44:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Fragmentos", emoji: "💎", xp: 250, em: "2026-09-25T07:44:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 300, em: "2026-09-24T05:44:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Gold", emoji: "🪙", xp: 250, em: "2026-09-23T19:44:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-22T20:44:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Fragmentos", emoji: "💎", xp: 250, em: "2026-09-22T13:44:00.000Z" },
      ],
    },
    jinbe_mar: {
      membroDesde: "2026-03-08T16:25:00.000Z",
      atividades: [
        { key: "sea_beast", nome: "Sea Beast", emoji: "🌊", vezes: 9, total: 9 },
        { key: "terroshark", nome: "Terroshark", emoji: "🦈", vezes: 6, total: 6 },
        { key: "raid", nome: "Raid", emoji: "🧨", vezes: 4, total: 4 },
        { key: "volcano", nome: "Ilha do Vulcão", emoji: "🌋", vezes: 2, total: 2 },
      ],
      insignias: [],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "Sea Beast", emoji: "🌊", xp: 250, em: "2026-09-25T19:57:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 15", emoji: "⬆️", xp: null, em: "2026-09-25T01:57:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Ilha do Vulcão", emoji: "🌋", xp: 500, em: "2026-09-25T01:57:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Raid", emoji: "🧨", xp: 250, em: "2026-09-23T18:57:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Terroshark", emoji: "🦈", xp: 250, em: "2026-09-23T03:57:00.000Z" },
      ],
    },
    usopp_sniper: {
      membroDesde: "2026-05-22T19:05:00.000Z",
      atividades: [
        { key: "pvp_loss", nome: "PvP derrota", emoji: "🥈", vezes: 12, total: 12 },
        { key: "pvp_win", nome: "PvP vitória", emoji: "🥇", vezes: 7, total: 7 },
        { key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 5, total: 60 },
        { key: "terroshark", nome: "Terroshark", emoji: "🦈", vezes: 2, total: 2 },
      ],
      insignias: [],
      historico: [
        { tipo: "ATIVIDADE", rotulo: "PvP vitória", emoji: "🥇", xp: 400, em: "2026-09-25T19:10:00.000Z" },
        { tipo: "NIVEL", rotulo: "Subiu para o nível 15", emoji: "⬆️", xp: null, em: "2026-09-24T20:10:30.000Z" },
        { tipo: "ATIVIDADE", rotulo: "PvP derrota", emoji: "🥈", xp: 100, em: "2026-09-24T20:10:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Terroshark", emoji: "🦈", xp: 250, em: "2026-09-24T13:10:00.000Z" },
        { tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 240, em: "2026-09-23T17:10:00.000Z" },
      ],
    },
    "300000000000000008": {
      membroDesde: "2026-07-01T20:10:00.000Z",
      atividades: [
        { key: "gold", nome: "Gold", emoji: "🪙", vezes: 4, total: 360000 },
        { key: "fragments", nome: "Fragmentos", emoji: "💎", vezes: 3, total: 12500 },
        { key: "ghost_ship", nome: "Navio Fantasma", emoji: "👻", vezes: 1, total: 1 },
      ],
      insignias: [],
      historico: [{ tipo: "ATIVIDADE", rotulo: "Fragmentos", emoji: "💎", xp: 250, em: "2026-09-25T18:23:00.000Z" }],
    },
    "300000000000000011": {
      membroDesde: "2026-09-20T22:00:00.000Z",
      atividades: [{ key: "quiz", nome: "Quiz", emoji: "🧠", vezes: 2, total: 26 }],
      insignias: [],
      historico: [{ tipo: "ATIVIDADE", rotulo: "Quiz", emoji: "🧠", xp: 260, em: "2026-09-25T17:36:00.000Z" }],
    },
  },
};
